/** @prettier */

import React, {useState} from 'react';
import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {useNavigate, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
//API import
import {deleteCompositionsSites} from '../../API/API_Collection';

import {routeList} from '../PrivateRoute';

//interface import
import * as apiIF from '../../Type/api';
import {checkSiteInfoBillingStatus} from '../../functions/checkBillingStatus';

/**
 * サイトの削除
 * @param props props
 * @returns JSX
 */
const SiteDeleteDialog = (props: {
  siteName: string;
  isOpenDialog: boolean;
  siteBillingStatus: apiIF.res.getCompositionsSitesBySiteID['billing-status'];
  setIsOpenDialog: (arg0: boolean) => void;
}) => {
  const trans = useTranslation().t; //翻訳関数
  const navigate = useNavigate();
  //パスパラメータ取得
  const {siteID} = useParams();

  const [checked, setChecked] = useState(false); //チェックボックス
  const [disable, setDisable] = useState(true); //OKボタン非表示フラグ
  const [errorOpen, setErrorOpen] = useState(false); //APIエラー時エラーメッセージ表示
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  /**
   * OKボタン押下時処理
   */
  const siteDelete = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) {
      return;
    }

    setAPIWait(true);
    setDisable(true);

    //サイトの削除
    deleteCompositionsSites(siteID)
      .then(response => {
        // ローカルストレージにあるサイト選択情報を削除する
        localStorage.removeItem('viewSubContentData');
        // サイト一覧画面に遷移
        navigate(routeList.mySite.path);
        // ダイアログを閉じる
        handleClose();
      })
      .catch(() => {
        setErrorOpen(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
    setDisable(true);
    setChecked(false);
  };

  /**
   * チェックボックスの値変更時の処理
   * @param event
   * @param check
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    setDisable(!event.target.checked);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('SiteDeleteDialog.title')}
        </DialogTitle>
        <DialogContent>
          {/* 現在のサイト名称を表示 */}
          <DialogContentText>
            {`${trans('SiteDeleteDialog.msg.siteName')} ${props.siteName}`}
          </DialogContentText>
          <DialogContentText>
            {checkSiteInfoBillingStatus(props.siteBillingStatus) && (
              <span className="siteDeleteDialog__paidErrorMsg">
                {trans('SiteDeleteDialog.msg.paidErrorMsg')}
              </span>
            )}
          </DialogContentText>
          {/* チェックボックス */}
          {checkSiteInfoBillingStatus(props.siteBillingStatus) === false && (
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={e => handleChange(e)}
                    id={`mv-Check1DeleteSite`}
                  />
                }
                checked={checked}
                label={trans('SiteDeleteDialog.checkboxDescription')}
              />
            </FormGroup>
          )}
        </DialogContent>
        {/* OK/CANCELボタン */}
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('SiteDeleteDialog.buttonTxt.cancel')}
            id={`mv-btnCancelDeleteSite`}
          />
          <PrimaryButton
            onClick={siteDelete}
            buttonText={trans('SiteDeleteDialog.buttonTxt.ok')}
            id={`mv-btnOkDeleteSite`}
            disabled={disable}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      {/* エラーメッセージ */}
      <APIErrorMessage
        open={errorOpen}
        setOpen={setErrorOpen}
        id={`DeleteErrDlgBtn`}
      />
    </>
  );
};
export default SiteDeleteDialog;
